/**
 * <set-builder-v2>  —  sections/set-builder-v2.liquid
 *
 * v1'den (assets/set-builder.js) bilerek ayri: v1 canli sayfayi yonetiyor,
 * bu dosya ona dokunmadan yeni kurguyu tasiyor.
 *
 * Sepete ekleme yolu yine assets/product-form.js'e birakiliyor; bu dosya
 * secim durumunu yonetir, paket slotlarini ve yapiskan cubugu cizer, form
 * gonderilmeden once gizli property alanlarini yazar.
 */
if (!customElements.get("set-builder-v2")) {
  customElements.define(
    "set-builder-v2",
    class SetBuilderV2 extends HTMLElement {
      connectedCallback() {
        const q = (sel) => this.querySelector(sel);

        this.max = Number(this.dataset.picks) || 5;
        this.picks = [];

        this.list = q("[data-sbv2-list]");
        this.slots = q("[data-sbv2-slots]");
        this.counter = q("[data-sbv2-counter]");
        this.search = q("[data-sbv2-search]");
        this.searchStatus = q("[data-sbv2-search-status]");
        this.empty = q("[data-sbv2-empty]");
        this.dots = q("[data-sbv2-dots]");
        this.barPrice = q("[data-sbv2-bar-price]");
        this.variantInput = q("[data-sbv2-variant]");
        this.propsHost = q("[data-sbv2-props]");
        this.submit = q("[data-sbv2-submit]");
        this.ctaLabel = q("[data-sbv2-cta-label]");
        this.picker = q("[data-sbv2-picker]");
        this.form = q("form");
        this.scrollCta = q("[data-sbv2-scroll]");

        if (!this.list || !this.form) return;

        const checked = q("[data-sbv2-size]:checked");
        this.size = {
          id: this.variantInput ? this.variantInput.value : "",
          label: checked ? checked.dataset.label : "",
          price: checked ? checked.dataset.price : (q("[data-sbv2-price-now]")?.textContent || "").trim(),
        };

        this.onListChange = this.onListChange.bind(this);
        this.onSlotsClick = this.onSlotsClick.bind(this);
        this.onSizeChange = this.onSizeChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onScrollCta = this.onScrollCta.bind(this);

        this.list.addEventListener("change", this.onListChange);
        this.slots?.addEventListener("click", this.onSlotsClick);
        this.addEventListener("change", this.onSizeChange);
        this.search?.addEventListener("input", this.onSearch);
        this.scrollCta?.addEventListener("click", this.onScrollCta);

        // Capture fazi SART: product-form.js submit'i bubble fazinda dinliyor,
        // eksik secimle sepete eklemeyi ondan once durdurmamiz gerekiyor.
        this.form.addEventListener("submit", this.onSubmit, { capture: true });

        this.restore();
        this.render();
        this.augment();
      }

      disconnectedCallback() {
        this.list?.removeEventListener("change", this.onListChange);
        this.slots?.removeEventListener("click", this.onSlotsClick);
        this.removeEventListener("change", this.onSizeChange);
        this.search?.removeEventListener("input", this.onSearch);
        this.scrollCta?.removeEventListener("click", this.onScrollCta);
        this.form?.removeEventListener("submit", this.onSubmit, { capture: true });
        clearTimeout(this.searchTimer);
      }

      /* ---------------- secim ---------------- */

      rows() {
        return [...this.list.querySelectorAll(".sbv2-row")];
      }

      rowFor(handle) {
        return this.list.querySelector(`.sbv2-row[data-handle="${CSS.escape(handle)}"]`);
      }

      titleFor(handle) {
        const row = this.rowFor(handle);
        return row ? row.dataset.title : handle;
      }

      onListChange(event) {
        const input = event.target.closest("[data-sbv2-input]");
        if (!input) return;
        const row = input.closest(".sbv2-row");
        if (!row) return;

        const handle = row.dataset.handle;
        if (this.picks.includes(handle)) {
          this.picks = this.picks.filter((h) => h !== handle);
        } else if (this.picks.length >= this.max) {
          // Karolari devre disi birakmiyoruz: tik geri aliniyor ve sebebi
          // duyuruluyor. Aksi halde klavye kullanicisi kurali ogrenemez.
          input.checked = false;
          this.warn(this.interpolate(this.dataset.limitText));
          return;
        } else {
          this.picks = [...this.picks, handle];
        }
        this.persist();
        this.render();
      }

      onSlotsClick(event) {
        const button = event.target.closest("[data-remove-handle]");
        if (!button) return;
        const handle = button.dataset.removeHandle;
        this.picks = this.picks.filter((h) => h !== handle);
        this.persist();
        this.render();
        // Odak bosluga dusmesin.
        (this.search || this.counter)?.focus?.({ preventScroll: true });
      }

      onSizeChange(event) {
        const radio = event.target.closest("[data-sbv2-size]");
        if (!radio) return;

        this.size = { id: radio.dataset.variantId, label: radio.dataset.label, price: radio.dataset.price };
        if (this.variantInput) this.variantInput.value = radio.dataset.variantId;

        const now = this.querySelector("[data-sbv2-price-now]");
        const was = this.querySelector("[data-sbv2-price-was]");
        const pill = this.querySelector("[data-sbv2-pill]");
        if (now) now.textContent = radio.dataset.price || "";
        if (was) was.textContent = radio.dataset.compare || "";
        if (pill) {
          const pct = Number(radio.dataset.percent) || 0;
          pill.textContent = pct > 0
            ? String(this.dataset.savingsText || "").replace(/\|\|percent\|\|/g, pct)
            : "";
        }
        this.render();
      }

      onScrollCta(event) {
        if (!this.picker) return;
        event.preventDefault();
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.picker.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
        setTimeout(() => this.search?.focus({ preventScroll: true }), reduce ? 0 : 450);
      }

      /* ---------------- cizim ---------------- */

      render() {
        this.renderRows();
        this.renderSlots();
        this.renderCounter();
        this.renderBar();
        this.renderButton();
        this.syncProps();
      }

      renderRows() {
        this.rows().forEach((row) => {
          const input = row.querySelector("[data-sbv2-input]");
          const check = row.querySelector(".sbv2-check");
          const index = this.picks.indexOf(row.dataset.handle);
          if (input) input.checked = index !== -1;
          if (check) check.textContent = index === -1 ? "" : String(index + 1);
        });
      }

      renderSlots() {
        if (!this.slots) return;
        const emptyText = this.dataset.emptySlotText || "";
        const items = [];
        for (let i = 0; i < this.max; i += 1) {
          const li = document.createElement("li");
          li.className = "sbv2-slot";
          const handle = this.picks[i];
          if (handle) {
            const title = this.titleFor(handle);
            li.classList.add("is-filled");
            const name = document.createElement("span");
            name.textContent = title;
            const remove = document.createElement("button");
            remove.type = "button";
            remove.className = "sbv2-slot-remove";
            remove.dataset.removeHandle = handle;
            remove.setAttribute("aria-label", `${title} kaldır`);
            remove.textContent = "×";
            li.append(name, remove);
          } else {
            li.textContent = emptyText;
          }
          items.push(li);
        }
        this.slots.replaceChildren(...items);
      }

      renderCounter() {
        if (!this.counter) return;
        this.counter.classList.remove("sbv2-counter--warn");
        this.counter.textContent = this.interpolate(this.dataset.counterText);
      }

      renderBar() {
        if (this.dots) {
          const dots = [];
          for (let i = 0; i < this.max; i += 1) {
            const dot = document.createElement("span");
            dot.className = "sbv2-bar-dot" + (i < this.picks.length ? " is-on" : "");
            dots.push(dot);
          }
          this.dots.replaceChildren(...dots);
        }
        if (this.barPrice && this.size.price) this.barPrice.textContent = this.size.price;
      }

      renderButton() {
        const complete = this.isComplete();
        if (this.submit) {
          if (complete) this.submit.removeAttribute("aria-disabled");
          else this.submit.setAttribute("aria-disabled", "true");
        }
        if (this.ctaLabel) {
          this.ctaLabel.textContent = complete
            ? this.dataset.completeText || ""
            : this.interpolate(this.dataset.incompleteText);
        }
      }

      /**
       * Property alanlarini her seferinde sifirdan kurar. Bayat dolu bir
       * deger yanlis kokuyu siparise gonderirdi.
       */
      syncProps() {
        if (!this.propsHost) return;
        const prefix = this.dataset.prefix || "Koku";
        const inputs = this.picks.map((handle, i) =>
          this.hidden(`properties[${i + 1}. ${prefix}]`, this.titleFor(handle)),
        );
        if (this.size.label) inputs.push(this.hidden("properties[_set_boyut]", this.size.label));
        this.propsHost.replaceChildren(...inputs);
      }

      hidden(name, value) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        return input;
      }

      /* ---------------- gonderim ---------------- */

      isComplete() {
        return this.picks.length === this.max;
      }

      onSubmit(event) {
        if (this.isComplete()) {
          document.querySelector("cart-drawer")?.rememberOpener?.({ currentTarget: this.submit });
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        this.warn(this.interpolate(this.dataset.incompleteText));
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.picker?.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
        setTimeout(() => this.search?.focus({ preventScroll: true }), reduce ? 0 : 450);
      }

      /* ---------------- arama ---------------- */

      /**
       * Turkce duyarli anahtar. 'İ'.toLowerCase() JS'de birlesik noktali bir
       * karakter uretir ve 'i' ile eslesmez; ayrica "gul" yazan "GÜL"u bulmali.
       */
      normalize(value) {
        return String(value || "")
          .toLocaleLowerCase("tr")
          .normalize("NFD")
          .replace(/[̀-ͯ]/g, "")
          .replace(/ı/g, "i")
          .replace(/ş/g, "s")
          .replace(/ğ/g, "g")
          .replace(/ç/g, "c")
          .replace(/ö/g, "o")
          .replace(/ü/g, "u")
          .trim();
      }

      onSearch() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.applyFilter(), 150);
      }

      applyFilter() {
        const query = this.normalize(this.search ? this.search.value : "");
        let matches = 0;
        this.rows().forEach((row) => {
          if (!row.dataset.search) row.dataset.search = this.normalize(row.dataset.title);
          const hit = !query || row.dataset.search.includes(query);
          row.classList.toggle("is-filtered", !hit);
          if (hit) matches += 1;
        });
        if (this.empty) this.empty.hidden = matches !== 0;
        if (this.searchStatus) {
          this.searchStatus.textContent = query
            ? String(this.dataset.searchStatusText || "").replace(/\|\|count\|\|/g, matches)
            : "";
        }
      }

      /* ---------------- yardimcilar ---------------- */

      interpolate(template) {
        const selected = this.picks.length;
        return String(template || "")
          .replace(/\|\|selected\|\|/g, selected)
          .replace(/\|\|total\|\|/g, this.max)
          .replace(/\|\|remaining\|\|/g, Math.max(0, this.max - selected));
      }

      warn(message) {
        if (!this.counter) return;
        this.counter.textContent = message;
        this.counter.classList.remove("sbv2-counter--warn");
        void this.counter.offsetWidth; // animasyonu yeniden tetikle
        this.counter.classList.add("sbv2-counter--warn");
      }

      storageKey() {
        const host = this.closest("[data-section-id]");
        return `sbv2:${host ? host.dataset.sectionId : "default"}`;
      }

      persist() {
        try {
          sessionStorage.setItem(this.storageKey(), JSON.stringify({ picks: this.picks }));
        } catch (e) {
          /* gizli mod / kota: kalicilik olmasin, akis bozulmasin */
        }
      }

      restore() {
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.storageKey()) || "null");
          if (!saved || !Array.isArray(saved.picks)) return;
          this.picks = saved.picks
            .filter((h) => {
              const row = this.rowFor(h);
              return row && row.dataset.available === "true";
            })
            .slice(0, this.max);
        } catch (e) {
          /* bozuk kayit: temiz baslat */
        }
      }

      /**
       * Yedek: sunucu 250 urune kadar basiyor. Koleksiyon bundan buyukse ya da
       * paginate beklenmedik sekilde eksik donerse kalanini koleksiyon
       * JSON'undan tamamlar ve listeyi alfabetik yeniden siralar.
       */
      async augment() {
        const handle = this.dataset.collectionHandle;
        const total = Number(this.dataset.collectionCount) || 0;
        if (!handle || total <= this.rows().length) return;

        const qualify = (this.dataset.qualifyTitle || "5 ML").trim().toUpperCase();
        const hideSoldOut = this.dataset.hideSoldOut === "true";
        const seen = new Set(this.rows().map((r) => r.dataset.handle));
        let added = 0;

        try {
          for (let page = 1; page <= 10; page += 1) {
            const res = await fetch(
              `${window.Shopify?.routes?.root || "/"}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`,
            );
            if (!res.ok) break;
            const { products } = await res.json();
            if (!products || !products.length) break;
            products.forEach((product) => {
              if (seen.has(product.handle)) return;
              const variant = product.variants.find((v) => String(v.title).trim().toUpperCase() === qualify);
              if (!variant || (hideSoldOut && !variant.available)) return;
              seen.add(product.handle);
              this.list.append(this.buildRow(product, variant));
              added += 1;
            });
            if (products.length < 250) break;
          }
        } catch (e) {
          return; // sunucudan gelen liste zaten calisiyor
        }

        if (!added) return;
        const sorted = this.rows().sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, "tr"));
        this.list.replaceChildren(...sorted);
        this.restore();
        this.render();
        if (this.search && this.search.value) this.applyFilter();
      }

      buildRow(product, variant) {
        const id = `Sbv2Row-x-${this.rows().length + 1}`;
        const li = document.createElement("li");
        li.className = "sbv2-row" + (variant.available ? "" : " is-unavailable");
        li.dataset.handle = product.handle;
        li.dataset.title = product.title;
        li.dataset.available = String(!!variant.available);

        const input = document.createElement("input");
        input.type = "checkbox";
        input.id = id;
        input.setAttribute("data-sbv2-input", "");
        if (!variant.available) input.disabled = true;

        const label = document.createElement("label");
        label.className = "sbv2-row-label";
        label.htmlFor = id;
        const check = document.createElement("span");
        check.className = "sbv2-check";
        check.setAttribute("aria-hidden", "true");
        const name = document.createElement("span");
        name.className = "sbv2-row-name";
        name.textContent = product.title;
        label.append(check, name);

        li.append(input, label);
        return li;
      }
    },
  );
}
